import { useMutation } from '@apollo/client'
import { Box, Button } from '@factorialco/deprecated-design-system'
import { BulkDeleteItAssetsDocument } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  ids: string[]
  onClose: () => void
}

export const BulkDeleteItAssetsModal = ({ ids, onClose }: Props) => {
  const [bulkDeleteItAssets, { loading: bulkDeleteLoading }] = useMutation(
    BulkDeleteItAssetsDocument
  )

  const handleBulkDeleteAssets = async () => {
    try {
      await bulkDeleteItAssets({
        variables: { ids: ids },
        refetchQueries: ['ItAssetsTable', 'ItAssetDetails', 'ItAssetsStatusCounts'],
        awaitRefetchQueries: true,
      })
      app.setFlash({
        type: 'correct',
        message: i18n.t('it_management.assets.bulk_delete_modal.success_message'),
      })
      onClose()
    } catch (error) {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('it_management.assets.bulk_delete_modal.error_message'),
      })
    }
  }

  return (
    <Modal
      title={i18n.t('it_management.assets.bulk_delete_modal.title')}
      onClose={onClose}
      illustration={'delete-cross'}
      description={i18n.t('it_management.assets.bulk_delete_modal.description')}
      onSubmit={handleBulkDeleteAssets}
      footer={
        <Box gap="s8" flexDirection="row" alignItems="center" justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose} disabled={bulkDeleteLoading}>
            {i18n.t('common.cancel')}
          </Button>

          <Button type="negative" submit disabled={bulkDeleteLoading}>
            {bulkDeleteLoading ? i18n.t('common.deleting') : i18n.t('common.destroy')}
          </Button>
        </Box>
      }
    />
  )
}
